"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Ebook_exports = {};
__export(Ebook_exports, {
  default: () => Ebook_default
});
module.exports = __toCommonJS(Ebook_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.3398 4.58594C16.5221 4.58594 16.6784 4.65104 16.8086 4.78125C16.9388 4.91146 17.0039 5.06771 17.0039 5.25V12.75C17.0039 12.9323 16.9388 13.0885 16.8086 13.2188C16.6784 13.349 16.5221 13.4141 16.3398 13.4141H4.66016C4.47786 13.4141 4.32161 13.349 4.19141 13.2188C4.0612 13.0885 3.99609 12.9323 3.99609 12.75V5.25C3.99609 5.06771 4.0612 4.91146 4.19141 4.78125C4.32161 4.65104 4.47786 4.58594 4.66016 4.58594H16.3398ZM4.66016 3.58984C4.20443 3.58984 3.8138 3.7526 3.48828 4.07812C3.16276 4.40365 3 4.79427 3 5.25V12.75C3 13.2057 3.16276 13.5964 3.48828 13.9219C3.8138 14.2474 4.20443 14.4102 4.66016 14.4102H16.3398C16.7956 14.4102 17.1862 14.2474 17.5117 13.9219C17.8372 13.5964 18 13.2057 18 12.75V5.25C18 4.79427 17.8372 4.40365 17.5117 4.07812C17.1862 3.7526 16.7956 3.58984 16.3398 3.58984H4.66016ZM2.16016 16.4219C2.16016 16.2786 2.20573 16.1615 2.29688 16.0703C2.40104 15.9661 2.52474 15.9141 2.66797 15.9141H18.332C18.4753 15.9141 18.5924 15.9661 18.6836 16.0703C18.7878 16.1615 18.8398 16.2786 18.8398 16.4219C18.8398 16.5521 18.7878 16.6693 18.6836 16.7734C18.5924 16.8646 18.4753 16.9102 18.332 16.9102H2.66797C2.52474 16.9102 2.40104 16.8646 2.29688 16.7734C2.20573 16.6693 2.16016 16.5521 2.16016 16.4219ZM12.1602 7.45703V4.625C12.1602 4.57292 12.1797 4.52734 12.2188 4.48828C12.2708 4.4362 12.3229 4.41016 12.375 4.41016H15.2852C15.3503 4.41016 15.4023 4.4362 15.4414 4.48828C15.4805 4.52734 15.5 4.57292 15.5 4.625V7.45703C15.5 7.52214 15.4674 7.58073 15.4023 7.63281C15.3503 7.67188 15.2917 7.67839 15.2266 7.65234L13.8984 7.16406C13.8854 7.16406 13.8659 7.16406 13.8398 7.16406C13.8138 7.16406 13.7878 7.16406 13.7617 7.16406L12.4531 7.65234C12.375 7.67839 12.3034 7.67188 12.2383 7.63281C12.1862 7.58073 12.1602 7.52214 12.1602 7.45703Z",
      fill: "currentColor"
    }
  )
);
const SvgEbook = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Ebook_default = SvgEbook;
